import { AccountCircle } from "@mui/icons-material";
import {
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import "./home.css";
// import Stemlab101 from "../../assets/stemlab101.mp4";
import Stemlab101 from "../../assets/4aa87dfe25cd49e88c4c408d87ba4761_305780498_470482605088076_4930414296505215075_n.mp4";
import { getDevelopers } from "../../features/Developers/developerSlice";
import { toggleSignUp } from "../../features/modals/modalSlice";
import Fotter from "./Fotter";

const Home = () => {
  const { developer, developers } = useSelector((state) => state.developers);
  const { isLoggedIn } = useSelector((state) => state.auth);
  // const { attributes, home } = developer;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDevelopers());
  }, []);

  const [openLoginModal, setOpenLoginModal] = useState(false);

  const handleOpenLogin = () => {
    setOpenLoginModal(true);
  };

  const handleCloseLogin = () => {
    setOpenLoginModal(false);
  };
  return (
    <>
      {/* <CssBaseline /> */}
      <video autoPlay loop>
        <source src={Stemlab101} type="video/mp4" />
      </video>
      {/* <video src={Stemlab101} autoPlay loop /> */}
      <Box className="home">
        <Box className="overlay"></Box>
        <Container>
          <Grid
            container
            sx={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              height: "80vh",
              flexDirection: { xs: "row-reverse", sm: "row" },
            }}
          >
            <Grid item xs={12} sm={8} md={8}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  textAlign: "left",
                }}
              >
                <Box>
                  <Typography variant="h4">Hello World,</Typography>
                  <Typography variant="h6">
                    Are you a Developer and you wanna get a quick portfolio ?{" "}
                  </Typography>
                  <Typography>
                    Ma name is Dave, am a Full Stack Web Developer at
                    StemLab_kano and i made this for us{" "}
                  </Typography>
                  <Button
                    size="large"
                    sx={{ mt: 2, display: { xs: "none", md: "flex" } }}
                    variant="outlined"
                    onClick={() => dispatch(toggleSignUp())}
                  >
                    Sign Up
                  </Button>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-around",
                  flexDirection: "column",
                  mt: { xs: "20px" },
                }}
              >
                <AvatarGroup total={developers?.length}>
                  {developers?.length > 0 &&
                    developers?.map((developer) => {
                      const { attributes } = developer;
                      return (
                        <Avatar alt="Remy Sharp" src={attributes.photoUrl} />
                      );
                    })}
                  <Avatar
                    alt="Travis Howard"
                    src="/static/images/avatar/2.jpg"
                  />
                  <Avatar
                    alt="Agnes Walker"
                    src="/static/images/avatar/4.jpg"
                  />
                  <Avatar
                    alt="Trevor Henderson"
                    src="/static/images/avatar/5.jpg"
                  />
                </AvatarGroup>
              </Box>
            </Grid>
            {!isLoggedIn && (
              <Grid item sx={{ display: { xs: "flex", md: "none" } }} mt={3}>
                <Box sx={{ display: { xs: "flex", md: "none" } }}>
                  <Button
                    size="large"
                    sx={{ mt: 2 }}
                    variant="outlined"
                    onClick={() => dispatch(toggleSignUp())}
                  >
                    Sign Up
                  </Button>
                </Box>
              </Grid>
            )}
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Home;
